import { BotMappieVersion } from '@/domain/bot-mappie';

export const initialBotsData: BotMappieVersion = {
    id: '',
    created_at: '',
    bot_id: '',
    updated_at: '',
    name: '',
    description: '',
    language: 'en',
    channel: 'voice',
    mchannels_bot_id: '',
    omnichannel_config: {
        voice: {
            initial_user_response_timeout: 0,
            inactivity_timeout: 0,
            tts: {
                language: 'en-US',
                prosody: {
                    rate: '100%',
                },
                voice: '',
                provider: 'azure',
            },
            stt: {
                language: 'en-US',
                provider: '',
                end_of_speech_timeout: 0,
            },
        },
    },
    languages: [
        {
            name: 'English',
            endonym: 'English',
            code: 'en',
        },
        {
            name: 'Czech',
            endonym: 'Čeština',
            code: 'cs',
        },
    ],
    prompts: {
        WELCOME: {
            description: 'First welcome message',
            variants: {
                policy: 'sequential',
                lang: {
                    cs: [
                        {
                            text: 'Vítám vás...',
                        },
                        {
                            text: 'Vítejte...',
                        },
                    ],
                    en: [
                        {
                            text: 'Welcome...',
                        },
                        {
                            text: 'Hi...',
                        },
                    ],
                },
            },
        },
    },
    dialog: {
        modules: {
            my_inner_module: {
                type: 'PromptsRetrievalInnerModule',
                metadata: {
                    lang: {
                        en: {
                            name: 'My inner module',
                            description: 'Description of inner module.',
                        },
                    },
                },
                prompts: {
                    MODULE_ENTERED: {
                        variants: {
                            policy: 'sequential',
                            lang: {
                                cs: [
                                    {
                                        text: 'Modul navštíven - override',
                                    },
                                ],
                                en: [
                                    {
                                        text: 'Module entered - override.',
                                    },
                                ],
                            },
                        },
                    },
                    YES_NO_QUESTION: {
                        variants: {
                            policy: 'sequential',
                            lang: {
                                cs: [
                                    {
                                        text: 'Ano, ne otázka - override',
                                    },
                                ],
                                en: [
                                    {
                                        text: 'Yes, no question. - override.',
                                    },
                                ],
                            },
                        },
                    },
                },
                dialog: {
                    modules: {
                        my_yes_no_confirmation: {
                            type: 'YesNoConfirmation',
                            metadata: {
                                lang: {
                                    en: {
                                        name: 'My yes no module',
                                        description:
                                            'Description of my yes no module.',
                                    },
                                },
                            },
                            prompts: {
                                ACKNOWLEDGE_YES: {
                                    id: 'ACKNOWLEDGE_YES',
                                    variants: {
                                        policy: 'sequential',
                                        lang: {
                                            cs: [
                                                {
                                                    text: 'Super..',
                                                },
                                            ],
                                            en: [
                                                {
                                                    text: 'Ok..',
                                                },
                                            ],
                                        },
                                    },
                                },
                                ACKNOWLEDGE_NO: {
                                    ref: 'acknowledge_no_991ba1d2_ea12_490f_bb3d_e159024d73ba',
                                },
                            },
                        },
                    },
                },
            },
        },
    },
    globals: {
        prompts: {
            acknowledge_no_991ba1d2_ea12_490f_bb3d_e159024d73ba: {
                variants: {
                    policy: 'sequential',
                    lang: {
                        cs: [
                            {
                                text: 'Chápu... (from global prompts)',
                            },
                        ],
                        en: [
                            {
                                text: 'Understood... (from global prompts)',
                            },
                        ],
                    },
                },
            },
        },
    },
};
